import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './QuestionBadge.scss';

function getStatusClassName(status) {
  switch (Number(status)) {
    case 1:
      return 'aprovado';
    case 2:
    case 0:
      return 'reprovado';
    default:
      return undefined;
  }
}

const QuestionBadge = props => (
  <div
    className={classNames('question-badge', getStatusClassName(props.status), {
      selected: props.selected,
    })}
    onClick={props.onClick}
  >
    {props.position}
  </div>
);

QuestionBadge.propTypes = {};

export default QuestionBadge;
